
export class M_REMEMBER_ACC {

  
    ID: number;
    Sifre: string;
    Name: string;
    

 

}
export class REMEMBERACC_TABLE{
    static TableQuery(){
        var query = "CREATE TABLE IF NOT EXISTS M_REMEMBER_ACC " +
        "(" +
        "ID INTEGER PRIMARY KEY ASC," +
        "Sifre text," +
        "Name text,";
        
        return query;
    }
}










// WEBPACK FOOTER //
// ./src/models/M_REMEMBER_ACC.ts